export default __webpack_public_path__ + "static/media/sms-grey.b685a240.svg";